import React from "react";
import _ from 'lodash';
import { useMsal } from '@azure/msal-react';
import { DropdownNavItem } from "./dropdown-nav-item";
import { useEffect, useState } from "react";
import { useSignalR, useUserProfile, useMenus } from "../../../app";
import { arrayAny } from "../../../utils/arrayUtils";

const DropdownProfile = () => {

	const { instance, accounts } = useMsal();

	const signalRApi = useSignalR();
	const profile = useUserProfile();
	const menus = useMenus();

	const [userProfileImages, setUserProfileImages] = useState({ default: "./../../../assets/img/user/user-12.jpg" });
	const profileImage = profile && profile.aadProfileImage;
	const systemProfile = profile && profile.systemProfile;

	const handleUserUpdate = user => {
		if (!user || !user.id) return;
		setUserProfileImages(current => ({
			...current,
			[user.id]: user.thumbnailProfileImageIncludingSasToken
		}));
	};

	useEffect(() => {
		if (profileImage && systemProfile) {
			handleUserUpdate(systemProfile);
		}
	}, [profileImage, systemProfile]);

	useEffect(() => {
		if (!signalRApi) return;

		const handleHeartbeat = data => {
			handleUserUpdate(data.user);
		};

		signalRApi.subscribe("heartbeat", handleHeartbeat);

		return () => {
			// Safe to call even if not previously subscribed
			signalRApi.unsubscribe("heartbeat", handleHeartbeat);
		};

	}, [signalRApi]);

	const menuItems = (items, developerItems) => {

		let menuItems = [];

		if (developerItems) {
			menuItems = _.filter(items, item => item.rolesRequired.indexOf("Application.Developer") > -1);
		}
		else {
			menuItems = _.filter(items, item => item.rolesRequired.indexOf("Application.Developer") === -1);
		}

		return menuItems.map((menu, i) => (
			<DropdownNavItem key={i} menu={menu} />
		))
	};

	const logout = () => {
		console.log("log out!");

		if (arrayAny(accounts) && accounts[0].idTokenClaims) {
			localStorage.clear();
			sessionStorage.clear();

			const cookies = document.cookie.split(";");
			cookies.forEach(cookie => {
				const eqPos = cookie.indexOf("=");
				const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
				document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
			});

			instance.logoutRedirect({ account: accounts[0] });
		}
	}

	const profileImageKey = profile?.systemProfile?.id;
	const profileImageValue = profileImageKey ? userProfileImages[profileImageKey] : null;
	const isPlaceholderAvatar = !profileImageValue;
	const usingFallbackAvatar = isPlaceholderAvatar;
	const shouldAnimateAvatar = usingFallbackAvatar;
	const getMyUserProfileImage = () => usingFallbackAvatar ? userProfileImages.default : profileImageValue;
	const displayName = profile?.systemProfile?.displayName
		?? profile?.graphMe?.displayName
		?? accounts?.[0]?.name
		?? accounts?.[0]?.username
		?? "User";
	const hasMenus = arrayAny(menus);
	const standardMenuItems = hasMenus ? menuItems(menus, false) : [];
	const developerMenuItems = hasMenus ? menuItems(menus, true) : [];

	return accounts[0] ? (
		<div className="navbar-item navbar-user dropdown">
			<a href="#/" className="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
				<img className={shouldAnimateAvatar ? "pm-avatar-loading" : ""} src={getMyUserProfileImage()} alt="" />
				<span>
					<span className="d-none d-md-inline">{displayName}</span>
					<b className="caret"></b>
				</span>
			</a>
			<div className="dropdown-menu dropdown-menu-end me-1">
				{standardMenuItems}
				{
					arrayAny(developerMenuItems) ?
						<>
							<div className="dropdown-divider"></div>
							{developerMenuItems}
						</>
						:
						<></>
				}
				<div className="dropdown-divider"></div>
				<div style={{ cursor: "pointer" }} onClick={logout} className="dropdown-item">Log Out</div>
			</div>
		</div>
	)
		:
		(
			<div className="navbar-item navbar-user dropdown">
				<div className="navbar-link dropdown-toggle d-flex align-items-center">
					<span>
						<span className="d-none d-md-inline">Loading...</span>
					</span>
				</div>
			</div>
		)
}

export default DropdownProfile;
